import usePagination from 'hooks/usePagination'
import { useWalletActivity } from 'hooks/useWallet'

import { Box, Pagination, Typography } from '@mui/material'
import DefaultLayout from 'components/layout/DefaultLayout'
import ActivityItem from './ActivityItem'

import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { useAuth } from 'components/AuthProvider'
import { Vault } from './ActivityItem/ActivityItem'

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),

    '& > section': {
      width: '100%',
      margin: theme.spacing(2, 0, 3),

      '& > p': {
        textAlign: 'center'
      }
    }
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',

    margin: theme.spacing(2, 0, 0)
  }
}))

export default function Activity(): JSX.Element {
  const { classes } = useStyles()

  const { setToast } = useAuth()

  const [pagination, setPagination] = usePagination()
  const { page, perPage } = pagination || {}

  const { data, isLoading } = useWalletActivity(page, perPage)

  const entries = data?.entries ?? []
  const totalCount = data?.totalCount ?? 0
  const totalPages = perPage ? Math.ceil(totalCount / perPage) : 1

  if (data === undefined && !isLoading) {
    setToast({
      open: true,
      message: 'Failed to load activity',
      type: 'error',
      duration: 3000
    })
  }

  const handleChangePage = (_event: React.ChangeEvent<unknown>, page: number) =>
    setPagination({ page })

  return (
    <DefaultLayout heading='Account activity' showBackIcon loading={isLoading}>
      <div className={classes.container}>
        {entries.length ? (
          // Rows arrive in the Rails ShowActivity shape ActivityItem renders
          // natively — reference, group total, per-entry source presentation.
          entries.map(activity => (
            <ActivityItem
              key={activity.id}
              activity={activity}
              vault={(activity.vault ?? undefined) as unknown as Vault}
            />
          ))
        ) : (
          <Box component='section'>
            <Typography component='p'>
              Your account has no activity yet
            </Typography>
          </Box>
        )}
        {page && totalPages > 1 && entries.length ? (
          <Pagination
            className={classes.pagination}
            page={page}
            count={totalPages}
            onChange={handleChangePage}
          />
        ) : null}
      </div>
    </DefaultLayout>
  )
}
